export const humanizeName = (name: string) => {
  return name.replace(/[-_]/g, ' ').toUpperCase();
};
